import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import router from '../router'
import { FUNCAO_SERVIDOR } from '@/shared/constants'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        token: sessionStorage.getItem("ed543672Token"),
        loading: true,
        dialogMensagem: false,
        config: {
            baseUrlApi: process.env.VUE_APP_BASE_URL,            
            instituicao: {
                id: '',
                nome: '',
                participa_pre_matricula: '',
                creche: '',
                status_educacenso: ''
            },
            periodo: {
                id: '',
                nome: '',
                periodo_anterior_id: ''
            },
            parametros: {
                fase_matricula: '',
                periodo_letivo_situacao_academica: '',
                // 'diaria' | 'periodo' (parâmetro diario.frequencia_modo)
                frequencia_modo: 'diaria',
                // 'atividades' | 'media_periodo' (parâmetro diario.nota_modo)
                nota_modo: 'atividades'
            }
        },
        instituicoes: [],
        periodos: [],
        racas: [],
        //TELAS LIBERADAS PARA O PERFIL — VEM DO initSistema (config/recursos.php na api).
        //null SIGNIFICA "A API NÃO INFORMOU": O MENU CAI NO tipoUser ANTIGO.
        recursos: null,
        user: {
            imagem: '',
            name: '',
            email: '',
            tipo: '',
            instituicoes: []
        },
        msg: {
            smge_msg: '',
            smge_msg_video: '',
            smge_msg_instituicao: [],
            smge_msg_ref: '',
            smge_msg_user_type: []
        }
    },
    actions: {
        setInstituicao(context, value){            
            return new Promise((resolve, reject) => {

                context.commit('setInstituicao', context.state.instituicoes[value]);
                resolve();
            })
        },
        setPeriodo(context, value){
            return new Promise((resolve, reject) => {

                context.commit('setPeriodo', context.state.periodos[value]);
                resolve();
            })
        },
        async getUser(context){

            try{

                let response = await axios.get(`${context.state.config.baseUrlApi}/api/sistema/initSistema`, context.getters.getHeaderAuth);

                // Bloqueio por janela de acesso (acesso.horarios_por_perfil) — o backend
                // devolve { erro: { text } } quando o login ocorre fora do horário permitido.
                if(response.data.erro){

                    window.eventBus.$emit('alert', { msg: response.data.erro.text || response.data.erro, type: 'warning' });
                    context.commit('logout');
                    return;
                }

                // O professor (tipo 2) entra no web só para lançar frequência e notas (spec_diario: telas do diário
                // concentradas no web admin); o menu e a home dele mostram apenas essas telas.

                //SETA AS CREDENCIAIS DO USUÁRIO LOGADO
                context.commit('setUser', response.data.user);

                //SETA OS CADASTROS AUXILIARES CARREGADOS NO BOOT (fonte única — substitui constantes estáticas)
                context.commit('setRacas', response.data.racas);

                //SETA AS TELAS LIBERADAS PARA O PERFIL
                context.commit('setRecursos', response.data.recursos);

                //SETA A LISTAGEM DE PERÍODOS
                context.commit('setListPeriodos', response.data.periodos);

                //SETA O PERÍODO DO SISTEMA
                context.commit('setPeriodo', { id: response.data.parametros.periodo_letivo_base_id, nome: response.data.parametros.periodo_letivo_base_nome, periodo_anterior_id: response.data.parametros.periodo_anterior_id });

                //SETA OS PARÂMETROS DO SISTEMA
                context.commit('setParametros', {

                    fase_matricula: response.data.parametros.fase_matricula,
                    periodo_letivo_situacao_academica: response.data.parametros.periodo_letivo_situacao_academica,
                    frequencia_modo: response.data.frequencia_modo || 'diaria',
                    nota_modo: response.data.nota_modo || 'atividades'
                });

                //SETA MENSAGEM DO SISTEMA
                context.commit('setMsg', {
                    smge_msg: response.data.parametros.smge_msg,
                    smge_msg_video: response.data.parametros.smge_msg_video,
                    smge_msg_instituicao: response.data.parametros.smge_msg_instituicao,
                    smge_msg_ref: response.data.parametros.smge_msg_ref,
                    smge_msg_user_type: response.data.parametros.smge_msg_user_type
                });

                //SE O USER LOGADO PRECISA DE VÍNCULO COM INSTITUIÇÃO (professor incluso: lança frequência e notas no web)
                if([0, 1, 2, 3, 12].includes(Number(response.data.user.tipo))){

                    if(sessionStorage.getItem('ed543672Instituicao')){

                        context.commit('setInstituicao', JSON.parse(sessionStorage.getItem("ed543672Instituicao")));
                    } else {

                        if(response.data.user.instituicoes.length == 1){

                            context.commit('setInstituicao', response.data.user.instituicoes[0]);
    
                        }else{
    
                            context.commit('setInstituicao', false);
                        }
                    }

                }else{

                    context.commit('updateLoading', false);

                    context.commit('setListInstituicoes', response.data.instituicoes);
                }

            }catch(e){

                context.commit('logout');
            }

            //PROCESSA MENSAGENS DO SISTEMA
            let refMsg = null;
            if(context.state.msg.smge_msg_ref === 0) {

                refMsg = JSON.parse(sessionStorage.getItem('smge4278099refMsg'));

            } else {

                refMsg = JSON.parse(localStorage.getItem('smge4278099refMsg'));
            }
            
            if (                
                (
                    context.state.msg.smge_msg || 
                    context.state.msg.smge_msg_video
                ) &&
                context.state.msg.smge_msg_user_type && 
                context.state.msg.smge_msg_user_type.includes(Number(context.state.user.tipo)) && 
                (
                    !refMsg || 
                    (
                        refMsg && 
                        !refMsg.hasOwnProperty(context.state.user.id)
                    ) || 
                    (
                        refMsg && 
                        refMsg.hasOwnProperty(context.state.user.id) && 
                        refMsg[context.state.user.id] != context.state.msg.smge_msg_ref
                    )
                )
            ) {

                if(context.state.msg.smge_msg_ref || context.state.msg.smge_msg_ref === 0) {

                    if(context.state.msg.smge_msg_ref === 0) {

                        await sessionStorage.setItem('smge4278099refMsg', JSON.stringify({ ...refMsg, [context.state.user.id]: context.state.msg.smge_msg_ref }));
    
                    } else {
    
                        await localStorage.setItem('smge4278099refMsg', JSON.stringify({ ...refMsg, [context.state.user.id]: context.state.msg.smge_msg_ref }));
                    }
                }

                if(context.state.msg.smge_msg_instituicao) {           

                    for(let j in context.state.user.instituicoes) {

                        let user = context.state.user.instituicoes[j];

                        if(context.state.msg.smge_msg_instituicao.includes(user.id)) {

                            if(context.state.msg.smge_msg) {
                                context.state.dialogMensagem = true;
                            }
                        }
                    }        

                } else {
                
                    if(context.state.msg.smge_msg) {
                        context.state.dialogMensagem = true;
                    }
                }
            }


        }
    },
    mutations: {
        clearInstituicaoSelected(state, value){

            state.instituicao.id = '';
            state.instituicao.nome = '';
        },
        setListInstituicoes(state, value){

            state.instituicoes = value;
        },
        setListPeriodos(state, value){

            state.periodos = value;
        },
        setToken(state, value){

            state.token = value;
        },
        updateLoading(state, value){

            state.loading = value;
        },
        setInstituicao(state, value){
            
            if(!value){

                state.config.instituicao = false;
                sessionStorage.removeItem('ed543672Instituicao');

            }else{

                state.config.instituicao = { id: value.id, nome: value.nome, participa_pre_matricula: value.participa_pre_matricula, creche: value.creche, status_educacenso: value.status_educacenso };
                sessionStorage.setItem('ed543672Instituicao', JSON.stringify({ id: value.id, nome: value.nome, participa_pre_matricula: value.participa_pre_matricula, creche: value.creche, status_educacenso: value.status_educacenso }));
            }

            state.loading = false;

        },
        setPeriodo(state, value){

            state.config.periodo = { id: value.id, nome: value.nome, periodo_anterior_id: value.periodo_anterior_id };

        },
        setParametros(state, value){

            state.config.parametros = value;

        },
        setMsg(state, value){

            state.msg.smge_msg = value.smge_msg;
            state.msg.smge_msg_video = value.smge_msg_video;
            state.msg.smge_msg_instituicao = value.smge_msg_instituicao;
            state.msg.smge_msg_ref = value.smge_msg_ref;       
            state.msg.smge_msg_user_type = value.smge_msg_user_type;   
        },
        setUser(state, value){

            state.user = value;
        },
        setRacas(state, value){

            state.racas = Array.isArray(value) ? value : [];
        },
        setRecursos(state, value){

            state.recursos = Array.isArray(value) ? value : null;
        },
        logout(state, value){

            router.push('/login');
            state.config.instituicao = { id: '', nome: '' };
            state.token = null;
            state.loading = true;
            state.user = { imagem: '', name: '', email: '', tipo: '', instituicoes: [] };
            state.recursos = null;
            sessionStorage.removeItem('ed543672Token');
            sessionStorage.removeItem('ed543672Instituicao');
            window.eventBus = new Vue();
        },
        throwException(state, value) {

            console.log(String(value));

            // Antes o erro só ia para o console e a tela parava de carregar sem explicação.
            // Avisa o usuário em falha de rede ou erro interno (5xx); 4xx continua com quem chamou.
            const status = value && value.response ? value.response.status : null;

            if (window.eventBus && (status === null || status >= 500)) {
                window.eventBus.$emit('loading', false);
                window.eventBus.$emit('alert', {
                    msg: 'Não foi possível concluir a operação. Tente novamente em instantes.',
                    type: 'error'
                });
            }
        }
    },
    getters: {
        // Mapa código INEP (cod_censo) -> nome da raça/cor, montado a partir da tabela racas
        // carregada no boot. Substitui a constante estática RACA_COR nas telas de exibição.
        mapaRacaCor: state => {

            let mapa = {};
            (state.racas || []).forEach(r => { mapa[r.cod_censo] = r.nome; });
            return mapa;
        },
        // Mapa código INEP (codigo) -> nome da função/cargo de servidor.
        mapaFuncaoServidor: () => FUNCAO_SERVIDOR,
        getHeader: state => {

            let header = {
                'Content-Type': 'application/json',
                'Accept' : 'application/json'
            }
            return header;
        },
        getHeaderAuth: state => {

            let options = {

                headers : {
                    'Content-Type' : 'application/json',
                    'Accept' : 'application/json',
                    'Authorization' : `Bearer ${state.token}`
                }

            }
            return options;
        },
        getHeaderAuthExcel: state => {

            let options = {

                'responseType': 'blob',

                headers : {

                    'Authorization' : `Bearer ${state.token}`
                }

            }
            return options;
        },
        getHeaderFileAuth: state => {

            let options = {

                headers : {
                    'Content-Type' : ['application/json', 'multipart/form-data'],
                    'Accept' : 'application/json',
                    'Authorization' : `Bearer ${state.token}`
                }

            }
            return options;
        },
    }
})